import { Box } from 'theme-ui'

import Type, { GelType } from 'src/components/gel/Type'

const CardMeta = ({
  label,
  title,
  text,
  variant
}: {
  label?: string
  title: string
  text?: string
  variant?: GelType
}) => {
  return (
    <Box sx={{ color: 'text.primary' }}>
      {label && (
        <Type
          variant="Labels"
          as="p"
          sx={{
            mb: 4
          }}
        >
          {label.toUpperCase()}
        </Type>
      )}
      <Type
        variant={variant || 'SectionTitleSerif'}
        as="h3"
        className="card-title"
        sx={{
          mb: 4,
          pb: 1,
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {title}
      </Type>
      {text && (
        <Type
          variant="Body"
          sx={{
            mb: 2,
            display: '-webkit-box',
            WebkitLineClamp: 4,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {text}
        </Type>
      )}
    </Box>
  )
}

export default CardMeta
